import React, { ReactElement } from "react"

interface StripHTMLAndAddEllipsesProps {
  content: string
  maxLength: number
  className?: string
}

const StripHTMLAndAddEllipses = ({
  content,
  maxLength,
  className = "",
}: StripHTMLAndAddEllipsesProps): ReactElement => {
  const strippedText = content?.replace(/<[^>]*>/g, "")
  const withoutMedia = strippedText?.replace(/<\s*(img|video|audio)[^>]*>/gi, "")
  const truncatedText = withoutMedia?.slice(0, maxLength)
  const finalText = truncatedText + (withoutMedia?.length > maxLength ? "..." : "")

  return <div className={className} dangerouslySetInnerHTML={{ __html: finalText }} />
}

export default StripHTMLAndAddEllipses
